if (!customElements.get('motion-catalogue-options')) {
  customElements.define('motion-catalogue-options', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      const data = JSON.parse(this.querySelector('script[type="application/json"]').textContent);
      const current = data.rows.find(row => row.id === this.dataset.productId);
      if (!current) return;
      const root = this.dataset.root.replace(/\/$/, '');
      const makeLink = (row, label) => {
        const link = document.createElement('a');
        link.href = `${root}/products/${row.handle}`;
        const preview = new URLSearchParams(window.location.search).get('preview_theme_id');
        if (preview) link.search = new URLSearchParams({preview_theme_id: preview}).toString();
        link.textContent = label;
        if (row.id === current.id) link.setAttribute('aria-current', 'true');
        return link;
      };
      data.names.forEach((name, axis) => {
        const values = [...new Set(data.rows.map(row => row.values[axis]))];
        if (values.length < 2) return;
        const field = document.createElement('fieldset');
        const legend = document.createElement('legend');
        legend.textContent = name;
        const choices = document.createElement('div');
        choices.className = 'motion-catalogue-options__choices';
        values.forEach(value => {
          const candidates = data.rows.filter(row => row.values[axis] === value);
          candidates.sort((a,b) => {
            const score = row => row.values.reduce((sum,v,i) => sum + (i !== axis && v === current.values[i] ? 1 : 0),0);
            return score(b) - score(a);
          });
          const target = value === current.values[axis] ? current : candidates[0];
          const changedOthers = target.values.filter((v,i) => i !== axis && v !== current.values[i]);
          const label = changedOthers.length ? `${value} · ${changedOthers.join(' · ')}` : value;
          choices.append(makeLink(target,label));
        });
        field.append(legend,choices);
        this.querySelector('.motion-catalogue-options__fields').append(field);
      });

    }
  });
}
